import Vue from 'vue'
import searchForm from './searchForm/index.vue'
import TopOperationBox from './top-operation-box'
import BoxWithTitle from './box-with-title'
import AttachmentUpload from './AttachmentUpload'
import Interval from './Interval'
import Boxfold from './box-with-title-fold'

Vue.component('search-form', searchForm)
Vue.component('box-with-title', BoxWithTitle)
Vue.component('top-operation-box', TopOperationBox)
Vue.component('AttachmentUpload', AttachmentUpload)
Vue.component('Interval', Interval)
Vue.component('boxfold', Boxfold)



// WEBPACK FOOTER //
// ./src/components/index.js